module.exports = __webpack_public_path__ + "ef250d2e35f50f5d21a2200ffcfa3660.png";